'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdGroupAdd = function MdGroupAdd(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.6 21.6c3.4 0 10 1.7 10 5v3.4h-20v-3.4c0-3.3 6.7-5 10-5z m11.1 0.4c3.4 0.5 7.3 2.1 7.3 4.6v3.4h-5v-3.4c0-1.9-0.9-3.4-2.3-4.6z m-11.1-3.6c-2.7 0-5-2.3-5-5s2.3-5 5-5 5 2.2 5 5-2.2 5-5 5z m8.4 0c-0.5 0-1-0.1-1.5-0.3 1-1.3 1.5-2.9 1.5-4.7s-0.5-3.5-1.5-4.8c0.5-0.2 1-0.2 1.5-0.2 2.7 0 5 2.2 5 5s-2.3 5-5 5z m-16.6-1.8v3.4h-5v5h-3.4v-5h-5v-3.4h5v-5h3.4v5h5z' })
        )
    );
};

exports.default = MdGroupAdd;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/group-add.js
// module id = 3405
// module chunks = 168707334958949